import { Group, Image as KonvaImage, Rect, Text } from 'react-konva';
import React, { useEffect, useState } from 'react';

const FloorPlanViewport = ({ shape, isSelected, shapeRefs, onSelect, onDragEnd, onTransformEnd }) => {

    const labelHeight = 20;
    const labelWidth = 70;

    return (
        <Group
            x={shape.x}
            y={shape.y}
            draggable
            onClick={(e) => onSelect(e, shape.id)}
            onDragEnd={(e) => onDragEnd(e, shape.id)}
            onTransformEnd={(e) => onTransformEnd(e, shape.id)}
            ref={(node) => {
                if (shapeRefs?.current) {
                    shapeRefs.current[shape.id] = node;
                }
            }}
        >
            <Rect
                width={shape.width}
                height={shape.height}
                stroke="#007AFF"
                dash={[4, 4]}
                strokeWidth={1.5}
            />
            {!isSelected && <Rect
                x={(shape.width - labelWidth) / 2}
                y={- labelHeight / 2 - 2}
                width={labelWidth}
                height={labelHeight}
                fill="#007AFF"
                cornerRadius={4}
            />}
            {!isSelected && <Text
                x={(shape.width - labelWidth) / 2}
                y={- labelHeight / 2 - 2}
                width={labelWidth}
                height={labelHeight}
                text="Viewport"
                fill="white"
                align="center"
                verticalAlign="middle"
                fontSize={12}
            />}
        </Group>

    );
};

export default FloorPlanViewport;